"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MissingGlobalRegisterError = void 0;
class MissingGlobalRegisterError extends Error {
    constructor(type) {
        super(`A default ${type} must be registered. Please check @mirohq-internal/telemetry-logging library implementation`);
    }
}
exports.MissingGlobalRegisterError = MissingGlobalRegisterError;
//# sourceMappingURL=errors.js.map